import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Navigation hook
import './AdminPanel.css';
import Dashboard from './Dashboard';
import Messages from './Messages';
import UserManagement from './UserManagement';
import EmailandSms from './EmailandSms';
import AboutUs from './AboutUs';
import PrivacyPolicy from './PrivacyPolicy';
import FAQAdminPanelStyles from './FAQAdminPanelStyles';
import TermsConditions from './TermsConditions';
import SystemSettings from './Systemsettings';
import Homepanel from './Homepanel';
import ApplicationAdmin from './ApplicationAdmin';
import RegulationAdmin from './RegulationAdmin';
import DisclaimerAdmin from './DisclaimerAdmin';
import Kairaaadmin from './Kairaaadmin';
import ViewPayments from './ViewPayments';
import TransactionDetails from './TransactionDetails';
import PaymentSettings from './PaymentSettings';
import ManagePremium from './ManagePremium';
import Reports from './Reports';
import EventUpdate from './EventUpdate';

const AdminPanel = () => {
  const [activeSection, setActiveSection] = useState('Home');
  const [activeMenu, setActiveMenu] = useState('');
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isFrontEndSettingsOpen, setIsFrontEndSettingsOpen] = useState(false);
  const [isPaymentManagementOpen, setIsPaymentManagementOpen] = useState(false); // State for Payment Management submenu
  const [showDescription, setShowDescription] = useState(true); // State to control platform description visibility
  const navigate = useNavigate();

  const toggleSettings = () => {
    setIsSettingsOpen(!isSettingsOpen);
  };

  const toggleFrontEndSettings = () => {
    setIsFrontEndSettingsOpen(!isFrontEndSettingsOpen);
  };

  const togglePaymentManagement = () => {
    setIsPaymentManagementOpen(!isPaymentManagementOpen); // Toggle Payment Management submenu
  };

  const handleMenuClick = (section) => {
    setActiveSection(section);
    setActiveMenu(section);
    setShowDescription(false); // Hide description when a menu is clicked
  };

  // Handle Logout Function
  const handleLogout = () => {
    // Clear any stored authentication tokens
    localStorage.removeItem('authToken'); 
    // Redirect to the login page
    navigate('/login');
  };

  const renderContent = () => {
    switch (activeSection) {
      case 'Dashboard':
        return <Dashboard />;
      case 'Messages':
        return <Messages />;
      case 'User Management':
        return <UserManagement />;
      case 'Application Management':
        return <ApplicationAdmin />;
      case 'View Payments':
        return <ViewPayments />;
      case 'Transaction Details':
        return <TransactionDetails />;
      case 'Payment Settings':
        return <PaymentSettings />;
      case 'Manage Premium Plans':
        return <ManagePremium />;
      case 'Report & Analytics':
        return <Reports />;
      case 'kairaa':
        return <Kairaaadmin />;
      case 'EventUpdate':
        return <EventUpdate />;

      case 'System Settings':
        return <SystemSettings />;
      case 'Email & SMS Settings':
        return <EmailandSms />;
      case 'Home Page':
        return <Homepanel />;
      case 'About Us':
        return <AboutUs />;
      case 'Recognition':
        return <RegulationAdmin />;
      case 'Terms & Conditions':
        return <TermsConditions />;
      case 'Privacy Policy':
        return <PrivacyPolicy />;
      case 'FAQ':
        return <FAQAdminPanelStyles />;
      case 'Disclaimer':
        return <DisclaimerAdmin />;
      default:
    }
  };

  return (
    <div className="dashboard-container">
      <div className="sidebar-menu">

        <div className="sidebar0000">
          <ul>
            <li
              onClick={() => handleMenuClick('Dashboard')}
              className={activeMenu === 'Dashboard' ? 'active' : ''}
            >
              Dashboard
            </li>
            <li
              onClick={() => handleMenuClick('Messages')}
              className={activeMenu === 'Messages' ? 'active' : ''}
            >
              Messages
            </li>
            <li
              onClick={() => handleMenuClick('User Management')}
              className={activeMenu === 'User Management' ? 'active' : ''}
            >
              User Management
            </li>
            <li
              onClick={() => handleMenuClick('Application Management')}
              className={activeMenu === 'Application Management' ? 'active' : ''}
            >
              Application Management
            </li>
            <li
              onClick={togglePaymentManagement}
              className={activeMenu === 'Payment Management' ? 'active' : ''}
            >
              Payment Management
              <span className="arrow">{isPaymentManagementOpen ? '▼' : '▶'}</span>
            </li>
            {isPaymentManagementOpen && (
              <ul className="payment-management-submenu">
                <li
                  onClick={() => handleMenuClick('View Payments')}
                  className={activeMenu === 'View Payments' ? 'active' : ''}
                >
                  View Payments
                </li>
                <li
                  onClick={() => handleMenuClick('Manage Premium Plans')}
                  className={activeMenu === 'Manage Premium Plans' ? 'active' : ''}
                >
                  Manage Premium Plans
                </li>
                <li
                  onClick={() => handleMenuClick('Transaction Details')}
                  className={activeMenu === 'Transaction Details' ? 'active' : ''}
                >
                  Transaction Details
                </li>
                <li
                  onClick={() => handleMenuClick('Payment Settings')}
                  className={activeMenu === 'Payment Settings' ? 'active' : ''}
                >
                  Payment Settings
                </li>
              </ul>
            )}
            <li
              onClick={() => handleMenuClick('Report & Analytics')}
              className={activeMenu === 'Report & Analytics' ? 'active' : ''}
            >
              Report & Analytics
            </li>
            <li
              onClick={() => handleMenuClick('kairaa')}
              className={activeMenu === 'kairaa' ? 'active' : ''}
            >
              Startup
            </li>
            <li
              onClick={() => handleMenuClick('EventUpdate')}
              className={activeMenu === 'EventUpdate' ? 'active' : ''}
            >
              Event Update
            </li>

            <li className="settings-item" onClick={toggleSettings}>
              <span>Settings</span>
              <span className="arrow">{isSettingsOpen ? '▼' : '▶'}</span>
            </li>

            {isSettingsOpen && (
              <ul className="dropdown-menu">
                <li
                  onClick={() => handleMenuClick('System Settings')}
                  className={activeMenu === 'System Settings' ? 'active' : ''}
                >
                  System Settings
                </li>
                <li
                  onClick={() => handleMenuClick('Email & SMS Settings')}
                  className={activeMenu === 'Email & SMS Settings' ? 'active' : ''}
                >
                  Email & SMS Settings
                </li>
                <li
                  className="front-end-setting-item"
                  onClick={toggleFrontEndSettings}
                >
                  Front-end Settings
                  <span className="arrow">{isFrontEndSettingsOpen ? '▼' : '▶'}</span>
                </li>

                {isFrontEndSettingsOpen && (
                  <ul className="nested-dropdown">
                    <li
                      onClick={() => handleMenuClick('Home Page')}
                      className={activeMenu === 'Home Page' ? 'active' : ''}
                    >
                      Home Page
                    </li>
                    <li
                      onClick={() => handleMenuClick('About Us')}
                      className={activeMenu === 'About Us' ? 'active' : ''}
                    >
                      About Us
                    </li>
                    <li
                      onClick={() => handleMenuClick('Disclaimer')}
                      className={activeMenu === 'Disclaimer' ? 'active' : ''}
                    >
                      Disclaimer
                    </li>
                    <li
                      onClick={() => handleMenuClick('Recognition')}
                      className={activeMenu === 'Recognition' ? 'active' : ''}
                    >
                      Recognition
                    </li>
                    <li
                      onClick={() => handleMenuClick('Terms & Conditions')}
                      className={activeMenu === 'Terms & Conditions' ? 'active' : ''}
                    >
                      Terms & Conditions
                    </li>
                    <li
                      onClick={() => handleMenuClick('Privacy Policy')}
                      className={activeMenu === 'Privacy Policy' ? 'active' : ''}
                    >
                      Privacy Policy
                    </li>
                    <li
                      onClick={() => handleMenuClick('FAQ')}
                      className={activeMenu === 'FAQ' ? 'active' : ''}
                    >
                      FAQ
                    </li>
                  </ul>
                )}
              </ul>
            )}
          </ul>
        </div>
      </div>
      <div className="main-content">
        <div className="navbar">
          <input type="text" placeholder="Search..." className="search-input" />
          <div className="welcome-message">Welcome, Admin</div>
          <div className="logo">
            <img src="/images/avatar.jpeg" alt="Logo" className="logo-img" />
          </div>
          <button className="logout-button" onClick={handleLogout}>
            Logout
          </button>
        </div>

        {showDescription && (
          <div className="platform-description">
            <h2>ABOUT STARTUP CONNECT</h2>
            <p>
            Startup Connect is a dynamic platform that bridges the gap between entrepreneurs, startups, investors, and mentors, fostering collaboration and networking. Designed to nurture growth and innovation, the platform enables users to create detailed profiles, showcase their businesses, and connect with others based on their goals and needs. Startups can attract investors, gain visibility, and seek mentorship to refine their ideas into scalable businesses. Investors explore curated opportunities to identify promising ventures, while mentors share expertise to guide aspiring entrepreneurs toward success. With premium subscription plans, users access exclusive features, including advanced networking tools, priority visibility, and tailored recommendations. The platform’s user-friendly interface and AI-driven matchmaking ensure meaningful interactions, fostering a vibrant entrepreneurial community. Startup Connect provides a professional space for collaboration, unlocking growth potential and strengthening the global startup ecosystem by empowering users to build valuable relationships and achieve their aspirations.
            </p>
          </div>
        )}

        {showDescription && (
          <div className="platform-description">
            {/* Services We Offer section */}
            <section className="services-header">
              <h2>OUR SERVICES</h2>
            </section>

            <div className="services-container">
              <div className="service-card">
                <div className="service-icon">🔗</div>
                <h3>Connect with Startups</h3>
                <p>Investors and mentors can explore and connect with innovative startups.</p>
              </div>

              <div className="service-card">
                <div className="service-icon">🎓</div>
                <h3>Mentorship Programs</h3>
                <p>Empower startups with industry insights and guidance.</p>
              </div>

              <div className="service-card">
                <div className="service-icon">💼</div>
                <h3>Investment Opportunities</h3>
                <p>Discover startups aligned with your interests for collaboration.</p>
              </div>

              <div className="service-card">
                <div className="service-icon">⚙️</div>
                <h3>Customized Services</h3>
                <p>Access tailored resources to scale your startup effectively.</p>
              </div>
            </div>
          </div>
        )}

        <div className="content-area">{renderContent()}</div>
      </div>
    </div>
  );
};

export default AdminPanel;
